import {ApiService} from "../index";
import {APIConfig} from "../../../constants";

const getFacilityTypesList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.FACILITY_TYPE_LIST.METHOD](APIConfig.FACILITY_TYPE_LIST.URL, payload);
}

const getFacilityListLite = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.FACILITY_LIST_LITE.METHOD](APIConfig.FACILITY_LIST_LITE.URL, payload);
}

const verifyFacility = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.FACILITY_VERIFY.METHOD](APIConfig.FACILITY_VERIFY.URL, payload);
}

const addFacility = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.CREATE_FACILITY.METHOD](APIConfig.CREATE_FACILITY.URL, payload);
}


const addPrimaryContactDetails = (facilityId: number, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.FACILITY_PRIMARY_CONTACT_DETAILS_ADD.METHOD](APIConfig.FACILITY_PRIMARY_CONTACT_DETAILS_ADD.URL(facilityId), payload);

}

const sendAdminVerificationEmail = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.SEND_FACILITY_ADMIN_VERIFICATION_EMAIL.METHOD](APIConfig.SEND_FACILITY_ADMIN_VERIFICATION_EMAIL.URL, payload);
}

const validateAdminDetails = (facilityId: number, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.VALIDATE_FACILITY_ADMIN_EMAIL.METHOD](APIConfig.VALIDATE_FACILITY_ADMIN_EMAIL.URL(facilityId), payload);
}
const addAdmin = (facilityId: number, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_FACILITY_ADMIN.METHOD](APIConfig.ADD_FACILITY_ADMIN.URL(facilityId), payload);
}

const editAdminDetails = (facilityId: number, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.EDIT_ADMIN_DETAILS.METHOD](APIConfig.EDIT_ADMIN_DETAILS.URL(facilityId), payload);
}

const getFacilityDetails = (facilityId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_FACILITY_DETAILS.METHOD](APIConfig.GET_FACILITY_DETAILS.URL(facilityId), payload);
}
const linkPanelsToFacility = (facilityId: number, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.LINK_TEST_PANELS_TO_FACILITY.METHOD](APIConfig.LINK_TEST_PANELS_TO_FACILITY.URL(facilityId), payload);
}

const addPhysicianInformation = (facilityId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_FACILITY_PHYSICIAN_INFORMATION.METHOD](APIConfig.ADD_FACILITY_PHYSICIAN_INFORMATION.URL(facilityId), payload);
}
const editPhysicianInformation = (facilityId: any, physicianId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.EDIT_FACILITY_PHYSICIAN_INFORMATION.METHOD](APIConfig.EDIT_FACILITY_PHYSICIAN_INFORMATION.URL(facilityId, physicianId), payload);
}
const getPhysicianList = (facilityId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_FACILITY_PHYSICIAN_LIST.METHOD](APIConfig.GET_FACILITY_PHYSICIAN_LIST.URL(facilityId), payload);
}

const deletePhysician = (facilityId: any, physicianID: any) => {
    // @ts-ignore
    return ApiService[APIConfig.DELETE_FACILITY_PHYSICIAN.METHOD](APIConfig.DELETE_FACILITY_PHYSICIAN.URL(facilityId, physicianID));
}

const removePhysician = (facilityId: any, physicianID: any) => {
    // @ts-ignore
    return ApiService[APIConfig.REMOVE_FACILITY_PHYSICIAN.METHOD](APIConfig.REMOVE_FACILITY_PHYSICIAN.URL(facilityId, physicianID));
}
const updateFacilityUpdatePhysician = (facilityId: any, payload: any) => {
    return ApiService[APIConfig.FACILITY_UPDATE_PHYSICIAN.METHOD](APIConfig.FACILITY_UPDATE_PHYSICIAN.URL(facilityId), payload)
}

const recoverPhysician = (facilityId: any, physicianID: any) => {
    // @ts-ignore
    return ApiService[APIConfig.RECOVER_FACILITY_PHYSICIAN.METHOD](APIConfig.RECOVER_FACILITY_PHYSICIAN.URL(facilityId, physicianID));

}

const editFacilityDetails = (facilityID: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.EDIT_FACILITY_INFORMATION_DETAILS.METHOD](APIConfig.EDIT_FACILITY_INFORMATION_DETAILS.URL(facilityID), payload);
}

const toggleActiveStatus = (facilityId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.TOGGLE_FACILITY_ACTIVE_STATUS.METHOD](APIConfig.TOGGLE_FACILITY_ACTIVE_STATUS.URL(facilityId), payload);
}

const getFacilityPanels = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_FACILITY_PANELS.METHOD](APIConfig.GET_FACILITY_PANELS.URL, payload);
}
const downloadFacilityCSV = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.DOWNLOAD_FACILITY_CSV.METHOD](APIConfig.DOWNLOAD_FACILITY_CSV.URL, payload);
}

const getPhysicainDetails = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_PHYSICIAN_DETAILS.METHOD](APIConfig.GET_PHYSICIAN_DETAILS.URL, payload);

}

const getPhysicianDatabaseDetails = (npiNumber:string,payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_NPI_VERIFICATION.METHOD](APIConfig.GET_NPI_VERIFICATION.URL(npiNumber), payload);

}

const getFacilityAdminsList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_FACILITY_ADMINS_LIST.METHOD](APIConfig.GET_FACILITY_ADMINS_LIST.URL, payload);
}

const getFacilityUserDetails = () => {
    // @ts-ignore
    return ApiService[APIConfig.GET_FACILITY_USER_DETAILS.METHOD](APIConfig.GET_FACILITY_USER_DETAILS.URL);
}
const addFacilityUserDetails = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_FACILITY_USER_DETAILS.METHOD](APIConfig.ADD_FACILITY_USER_DETAILS.URL, payload);

}
const removeFacilityAssignedUser=(payload:any)=>{
    // @ts-ignore
    return ApiService[APIConfig.REMOVE_FACILITY_ASSIGNED_USER.METHOD](APIConfig.REMOVE_FACILITY_ASSIGNED_USER.URL,payload);

}
const updateFacilityUserLocation=(facilityId:string|number,userId:string|number,payload:any)=>{
    // @ts-ignore
    return ApiService[APIConfig.UPDATE_FACILITY_USER_LOCATION.METHOD](APIConfig.UPDATE_FACILITY_USER_LOCATION.URL(facilityId,userId),payload);
}

const FacilityService = {
    getFacilityListLite,
    getFacilityTypesList,
    verifyFacility,
    addFacility,
    getPhysicainDetails,
    getPhysicianDatabaseDetails,
    addPrimaryContactDetails,
    validateAdminDetails,
    downloadFacilityCSV,
    sendAdminVerificationEmail,
    linkPanelsToFacility,
    getFacilityDetails,
    addPhysicianInformation,
    getPhysicianList,
    deletePhysician,
    recoverPhysician,
    editFacilityDetails,
    editPhysicianInformation,
    toggleActiveStatus,
    editAdminDetails,
    getFacilityPanels,
    removePhysician,
    updateFacilityUpdatePhysician,
    addAdmin,
    getFacilityAdminsList,
    getFacilityUserDetails,
    addFacilityUserDetails,
    removeFacilityAssignedUser,
    updateFacilityUserLocation,
}

export default FacilityService;
